import $ from 'jquery';
import debug from 'debug';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-search-filter-year]';
const PLUGIN_NAME = 'searchFilterYear';

const log = debug('search/results-filter/search-filter-year:year');

class SearchFilterYear {
	constructor(element, options) {
		log('element', element);
		log('options', options);

		this.options = options;
		this.element = element;
		this.$element = $(element);

		this.form = this.selectors.selectTarget(
			'(parents) form',
			this.$element
		);

		this.yearSelect = this.selectors.selectTarget(
			this.options.yearSelectSelector,
			this.$element
		);

		this.watch();

		log('ready', this, this.$target);
	}

	watch() {
		log('watching');

		this.form.on('submit', this.onSubmit.bind(this));
		this.yearSelect.on('change', this.onChange.bind(this));
	}

	// trigger this method from parent date range
	reset() {
		this.yearSelect.val('');
	}

	onChange() {

		// update here to update All dates checkbox immediately

		this.$element.trigger('datechange');
	}

	onSubmit(event) {
		log('submit');
	}
}

SearchFilterYear.DEFAULTS = {};

plugin(PLUGIN_NAME, SearchFilterYear);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});




// WEBPACK FOOTER //
// ./project/client/src/site__vegkit/components/search/results-filter/search-filter-year.js